import { inject } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';

/**
 * Intercepts router.navigate calls to automatically preserve ALL query parameters
 * This is a monkey-patch solution that wraps the original navigate method
 */
export function setupQueryParamsInterceptor() {
  const router = inject(Router);

  // Store original navigate method
  const originalNavigate = router.navigate.bind(router);

  // Override navigate method
  router.navigate = function (
    commands: any[],
    extras?: NavigationExtras,
  ): Promise<boolean> {
    // If queryParamsHandling is already set, respect it
    if (
      extras?.queryParamsHandling === 'preserve' ||
      extras?.queryParamsHandling === 'merge'
    ) {
      return originalNavigate(commands, extras);
    }

    // Get current query params from URL
    const currentUrl = router.url;
    const urlTree = router.parseUrl(currentUrl);
    const currentQueryParams = urlTree.queryParams;

    // Merge ALL current query params with any new params provided
    // New params take precedence (can override existing ones)
    const mergedQueryParams = {
      ...currentQueryParams, // Preserve all current query params
      ...(extras?.queryParams || {}), // Override with any new params
    };

    // Create new extras with merged query params
    const newExtras: NavigationExtras = {
      ...extras,
      queryParams:
        Object.keys(mergedQueryParams).length > 0
          ? mergedQueryParams
          : undefined,
    };

    // Call original navigate with merged params
    return originalNavigate(commands, newExtras);
  };

  return () => {
    // Empty function required for APP_INITIALIZER
  };
}
